<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="'Therapies Info'"            
            v-bind:titleRef="'titleElementTherapies'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            Provide details about the available therapies in the form. When you're done, click <b>Save</b> to proceed.
        </p>

        <b-row>
            <b-col lg="3" md="3" sm="12">
              
            </b-col>
        </b-row>

     

        <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"           
            v-bind:Name="'btnTherapiesBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnTherapiesNext'"
            v-bind:ClassProp="'mx-2'"/>  

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="$t('Shared.Save')"
            v-bind:Name="'btnTherapies'"
            v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>



    </div>
   

</template>

<script>

export default {
  name: 'IniTherapies',
  data(){
    return{

    }
  },
  methods:{
    Next(){
        this.$router.push({ name:'iprograms'});
    },

    Back(){
        this.$router.push({ name:'iusers'}); 
    }
  },
  mounted(){

  }   
};
</script>


